import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';

import { useStore } from 'store';
import { Range, Input } from 'components';

import styles from './styles.module.scss';

export default function PriceFilter({
  prevCategory,
  setPrevCategory,
  setHasApliquedFilter
}) {
  const [prevPrices, setPrevPrices] = useState([0, 0]);

  const [prices] = useStore((state) =>
    _get(state, 'gifts.listOfGifts.results.prices', [0, 0])
  );
  const [MIN_PRICE, MAX_PRICE] = prices;

  const [category] = useStore((state) =>
    _get(state, 'gifts.listOfGifts.params.category', '')
  );

  const { setFieldValue, values } = useFormikContext();
  const { minPrice, maxPrice } = values;

  const handleRangePriceChange = ([newMinPrice, newMaxPrice]) => {
    setFieldValue('minPrice', newMinPrice);
    setFieldValue('maxPrice', newMaxPrice);
  };

  useEffect(() => {
    setPrevPrices(prices);
  }, [prices]);

  useEffect(() => {
    setFieldValue('minPrice', MIN_PRICE);
    setFieldValue('maxPrice', MAX_PRICE);
  }, [MIN_PRICE, MAX_PRICE]);

  useEffect(() => {
    if (
      !_isEqual(prices, prevPrices) &&
      category &&
      category !== prevCategory
    ) {
      setPrevCategory(category);

      setFieldValue('defaultMinPrice', MIN_PRICE);
      setFieldValue('defaultMaxPrice', MAX_PRICE);

      setHasApliquedFilter(false);
    }
  }, [prices, category]);

  return (
    <Row className={styles.priceFilter}>
      <Col xs={12}>
        <Range
          value={[minPrice, maxPrice]}
          min={MIN_PRICE}
          max={MAX_PRICE + 1}
          onChange={handleRangePriceChange}
          allowCross={false}
        />
      </Col>
      <Col xs={6} className="pl-0 pr-2">
        <Input
          name="minPrice"
          type="number"
          className={styles.priceInput}
          placeholder="Mínimo"
        />
      </Col>
      <Col xs={6} className="pr-0 pl-2">
        <Input
          name="maxPrice"
          type="number"
          className={styles.priceInput}
          placeholder="Máximo"
        />
      </Col>
    </Row>
  );
}

PriceFilter.propTypes = {
  prevCategory: PropTypes.number,
  setPrevCategory: PropTypes.func.isRequired,
  setHasApliquedFilter: PropTypes.func.isRequired
};
